import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'

import { useAuthStore } from '@/shared/auth/stores/authStore'
import { isHiddenEntity } from '@/shared/constants/demo-data'
import { TemplateBuilderPage } from '@/systems/entities/features/template-builder/components/TemplateBuilderPage'

interface CreateTemplateSearch {
  editId?: string | undefined
}

export const Route = createFileRoute('/entities/$id_/create-template')({
  beforeLoad: ({ params }) => {
    const { isAuthenticated } = useAuthStore.getState()
    if (!isAuthenticated) {
      throw redirect({ to: '/login' })
    }
    if (isHiddenEntity(params.id)) {
      throw redirect({ to: '/entities' })
    }
  },
  validateSearch: (search: Record<string, unknown>): CreateTemplateSearch => {
    const raw = search['editId']
    return {
      editId: typeof raw === 'string' && raw.length > 0 ? raw : undefined,
    }
  },
  component: CreateTemplateRoute,
})

function CreateTemplateRoute() {
  const { id } = Route.useParams()
  const { editId } = Route.useSearch()
  const navigate = useNavigate()

  return (
    <TemplateBuilderPage
      entityId={id}
      editTemplateId={editId}
      onBack={() =>
        navigate({ to: '/entities/$id', params: { id }, search: { tab: 'form_templates' } })
      }
      onDraftIdChange={(draftId) =>
        navigate({
          to: '/entities/$id/create-template',
          params: { id },
          search: { editId: draftId },
          replace: true,
        })
      }
    />
  )
}
